<template>
    <div class="time-y-m time-md-m">
        <el-date-picker
            ref="datePick"
            popper-class="time-zjy-widget-one-layer"
            v-model="value"
            class="input-details"
            type="datetime"
            placeholder="选择日期时间"
            style="width: 100%;"
            size="large"
            :picker-options="pickerOptionsLimit(config)"
            :default-value="nextMonthFun(config.limit || new Date())"
            format="YYYY-MM-DD HH:mm"
            value-format="YYYY-MM-DD HH:mm"
            :disabled="config.exhibiIs"
            @change="dateChange"
        ></el-date-picker>
        <div class="time-y-m-text">
            {{ getTimeYMD() }}
        </div>
        <div class="time-md">
            <el-select v-model="timeLabel" @change="(val) => getItt(config, val, 1)" placeholder="请选择" size="large">
            <el-option v-for="(itt, ittInd) in config.timeList.options" :key="ittInd + config.title" :value="itt.value" :label="itt.label" />
            </el-select>
            <!-- <div class="time-md-text">{{getTimeLabel(config.timeList.options, config.timeList.defaultValue) || '请选择'}}</div> -->
        </div>
    </div>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
import { limitDate, thisNoTime } from "@/api/utils";
import { formatDate } from '@/api/global'
export default {
    name: 'time-picker',
    props: {
        config: {
            type: Object
        },
        modifyId: String,
        timeWidthObj: Object,
        formdata: Object
    },
    data () {
        return {
            value: '',
            isClickPicker: false,
            isPickerVisible: false,
            timeLabel: ''
        }
    },
    watch: {
        formdata: {
            immediate: true,
            deep: true, 
            handler (val) {
                const type = this.config.title + '_' + this.config.type
                const vv = val ? val[type] : ''
                // console.log('值更新', vv, this.value)
                // if (vv !== this.value) {
                    // this.$set(this, 'value', vv)
                    this.value = vv
                    if (vv) {
                        // this.$set(this, 'timeLabel', vv.split(' ')[1])
                        this.timeLabel = vv.split(' ')[1]
                    }
                // }
            }
        }
        // time: {
        //     immediate: true,
        //     handler (val) {
        //         this.$set(this, 'value', val)
        //     }
        // }
    },
    methods: {
        getItt (item, value) {
            console.log('getItt==',item, value)
            const type = item.title + '_' + item.type
            if (this.formdata && this.formdata[type]) {
                const e = formatDate(new Date(this.formdata[type]), "yyyy-MM-dd")
                const str = e + ' ' + value
                this.formdata[type] = str
                console.log("111===",str)
                this.$emit('change', str)
            }
            // const type = item.title + '_' + item.type
            // const e = formatDate(new Date(formdata[type]), "yyyy-MM-dd")
            // const str = e + ' ' + value
            // this.$set(formdata, type, str)
            // switch (key) {
            //     case 1:
            //     this.approvalProcess(item)
            //     break
            // }
        },
        getTimeLabel (sels, defaultValue) {
            let val = this.timeLabel || ''
            if (!val && defaultValue) {
                for (const i of sels) {
                if (i.value === defaultValue) return i.label
                }
            }
            if (!val || !sels || sels.length === 0) return val
            for (const i of sels) {
                if (i.value === val) return i.label
            }
            return val
            // let val = this.formdata && this.config ? this.formdata[this.config.title + '_' + this.config.type] : ''
            // if (!val && defaultValue) {
            //     for (const i of sels) {
            //     if (i.value === defaultValue) return i.label
            //     }
            // }
            // if (!val || !sels || sels.length === 0) return val
            // const v = val.split(' ')[1]
            // for (const i of sels) {
            //     if (i.value === v) return i.label
            // }
            // const vvv = v ? v : val
            // return vvv
        },
        getTimeYMD () {
            let val = this.formdata && this.config ? this.formdata[this.config.title + '_' + this.config.type] : ''
            if (!val) return ''
            return formatDate(new Date(val), "yyyy-MM-dd")
        },
        dateChange (val) {
            const type = this.config.title + '_' + this.config.type
            console.log('dateChange', val, this.formdata[type])
            // this.$set(this.formdata, type, val)
            this.formdata[type] = val
            // this.$emit('update:formdata', ars)
            this.$emit('change')
            // if (!val) {
            //     console.log('返回空')
            //     this.$set(this.formdata, type, '')
            //     this.$emit('change', '')
            // } else if (val !== this.formdata[type]) {
            //     // this.value = this.formdata[type]
            //     this.$set(this.formdata, type, val)
            // }
        },
        // 时间限制
        pickerOptionsLimit(val) {
            if (this.modifyId) return "";
            let date = val.dayWeek;
            const self = this
            if (
                !val.dayWeek &&
                (val.limit === "week" ||
                val.limit === "nextWeek" ||
                val.limit === "dayWeek")
            )
            date = 7;
            const retLimitDate = limitDate(val.limit || "", date);
            // return limitDate(val.limit || "", date);
            console.log('返回时间限制', retLimitDate)
            // retLimitDate.onclick = () => {
            //     console.log('点击了确定')
            // }
            retLimitDate.shortcuts = [
                {
                    text: '确定',
                    onClick (picker) {
                        console.log('onclick', picker, picker.value)
                        const type = self.config.title + '_' + self.config.type
                        const str = picker.visibleDate + ' ' + (self.timeLabel || picker.visibleTime)
                        self.$set(self.formdata, type, str)
                        self.$emit('change', str)
                        // picker.handleTimePickClose()
                        picker.visible = false
                    }
                }
            ]
            retLimitDate.onPick = (picker) => {
                console.log('onPick', picker)
                // this.isClickPicker = true
            }
            return retLimitDate
        },
        // 不包含本日的时间返回可选的开始时间
        nextMonthFun(val) {
            return thisNoTime(val);
        },
    }
}
</script>

<style scoped lang="scss">
.time-md-m {
  display: flex;
  align-items: center;
  .time-md {
    width: 30%;
    max-width: 160px;
    min-width: 90px;
    position: relative;
    margin-left: 10px;
    .time-md-text {
      position: absolute;
      top: 0;
      left: 10px;
      pointer-events: none;
      line-height: 40px;
    }
  }
}
.time-y-m {
  position: relative;
  width: 100%;
  :deep(.el-input__inner) {
    color: #ffffff;
  }
  .time-y-m-text {
    position: absolute;
    top: 0;
    left: 30px;
    pointer-events: none;
    line-height: 40px;
  }
}
</style>

<style lang="scss">
.time-zjy-widget-one-layer {
    .el-picker-panel__sidebar {
        display: none;
    }
    .el-picker-panel__body {
        margin-left: 0;
        .el-picker-panel__content {
            width: calc(100% - 30px);
        }
    }
}
</style>
